import React from "react";
import WeeklyCheckInForm from "../components/clientCoachUpdates/clientSection/weeklyCheckInForm/WeeklyCheckInForm";
import Header from "../components/Header";
import Section from "../components/section/Section";

import {
  Box,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  Paper,
} from "@mui/material";
import styled from "styled-components";
import { tokens } from "../../theme";
import { MainContainer } from "./styles/sharedStyles";
import Title from "../components/title/Title";

const WeeklyCheckIn = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const smScreen = useMediaQuery(theme.breakpoints.up("sm"));
  return (
    <MainContainer>
      <Title title="Check-in" summary="A compléter chaque semaine" />
      <Section>
        <Paper elevation={3} style={{ padding: "2rem" }}>
          <Typography
            variant="body1"
            color={colors.grey[100]}
            align="left"
            display="block"
          >
            Ce petit bilan hebdomadaire est là pour t’aider à suivre tes progrès
            et voir tout le chemin parcouru. 😊
            <br /> Grâce à tes résultats, je pourrai ajuster ton programme pour
            qu’il soit parfaitement adapté à toi. 💪
            <br /> N’oublie pas, tu fais tout ça pour toi, et uniquement pour
            toi. Tu es la priorité ici ! 🌟
            <br /> Sois honnête avec toi-même, c’est le meilleur moyen de tirer
            le maximum de ce programme. Et surtout, rappelle-toi que je suis là
            pour t’accompagner et t’aider à atteindre tes objectifs. On forme
            une super équipe ! 🙌
          </Typography>
        </Paper>
      </Section>

      <Box m={2}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} md={8} lg={6}>
            <WeeklyCheckInForm />
          </Grid>
        </Grid>
      </Box>
    </MainContainer>
  );
};

export default WeeklyCheckIn;
